const en = {
  // ── Common ────────────────────────────────────────────────────────
  common: {
    cancel: 'CANCEL',
    close: 'CLOSE',
    apply: '✔ APPLY',
    save: 'SAVE',
    saving: 'SAVING...',
    loading: 'LOADING...',
    go: 'GO',
    coordsPlaceholder: 'x, y',
    copied: '✓ COPIED',
    share: '⎘ SHARE',
    backToMap   : 'To canvas',
    error       : 'ERROR: {{msg}}',
    navDashboard: 'MY PIXELS',
    navProfile  : 'PROFILE',
    navShop     : 'SHOP',
    navZones    : 'MY ZONES',
    navAdmin    : 'ADMIN',
    navLogout   : 'LOGOUT',
    navPlay     : '▶ PLAY',
    ofertaLink  : 'public offer',
    ofertaConsent: 'By clicking pay, you agree to the',
    ofertaNotice : 'By using the dashboard, you accept the terms of the',
  },

  // ── Auth pages ────────────────────────────────────────────────────
  auth: {
    signInHeading: 'SIGN IN',
    registerHeading: 'REGISTER',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm password',
    passwordPlaceholder: 'min. 6 characters',
    confirmPlaceholder: 'repeat password',
    loading: 'LOADING...',
    enterBtn: '▶ ENTER',
    createAccountBtn: '▶ CREATE ACCOUNT',
    noAccount: 'No account?\u00a0',
    createOne: 'Create one',
    alreadyRegistered: 'Already registered?\u00a0',
    signInLink: 'Sign in',
    backToMap: 'To canvas',
    passwordsNoMatch: 'Passwords do not match',
    registerSuccess: 'Registration successful, please check your email for confirmation',
    loginError: 'Login error',
    registerError: 'Registration error',
    oauthErrors: {
      unknown_provider: 'Unknown OAuth provider',
      invalid_state: 'OAuth security error. Please try again',
      no_code: 'Authorization cancelled',
      userinfo_failed: 'Failed to get data from provider',
      auth_failed: 'OAuth authentication error',
      oauth_failed: 'OAuth login error',
    },
    termTitleAuth: 'we-are-pixels · auth',
    termTitleRegister: 'we-are-pixels · register',
    or: 'or',
  },

  // ── Verify ────────────────────────────────────────────────────────
  verify: {
    verifying: 'VERIFYING EMAIL',
    pleaseWait: 'Please wait...',
    success: 'SUCCESS',
    redirecting: 'Redirecting to sign in in 3 seconds...',
    signInNow: '▶ SIGN IN NOW',
    error: 'ERROR',
    invalidLink: 'Invalid confirmation link',
    confirmError: 'Confirmation error',
    backToMap: '← TO CANVAS',
    termTitle: 'we-are-pixels · verify',
  },

  // ── Profile ───────────────────────────────────────────────────────
  profile: {
    heading: 'MY PROFILE',
    emailLabel: 'Email',
    accountType: 'Account type',
    oauthAccount: 'OAuth · {{provider}}',
    passwordAccount: 'Login and password',
    registrationDate: 'Registration date',
    changePassword: 'CHANGE PASSWORD',
    currentPassword: 'Current password',
    newPassword: 'New password',
    repeatPassword: 'Repeat new password',
    saving: 'SAVING...',
    saveBtn: 'SAVE',
    passwordsNoMatch: 'Passwords do not match',
    passwordTooShort: 'Minimum password length — 6 characters',
    passwordChanged: 'Password changed successfully',
    passwordChangeError: 'Password change error',
    oauthPasswordNote: 'Password change is not available for OAuth accounts',
    syntheticEmailHint: 'Generated from OAuth provider',
    loadError: 'Failed to load profile',
    zonePointTitle: 'CREATE POINT IN ZONE',
    zonePointZone: 'Active zone',
    zonePointName: 'Point name',
    zonePointBtn: 'CREATE IN ZONE',
    zonePointCreating: 'CREATING...',
    zonePointCreated: 'Point created inside the selected zone',
    zonePointError: 'Failed to create point in zone',
    zonePointNoZones: 'No active zones',
    zonePointNoZonesHint: 'Activate or purchase a zone first to place a new point inside it.',
    zonePointHint: 'The new point will spawn at the nearest free cell inside the selected active zone.',
    zonePointZoneRequired: 'Select a zone before creating a point',
    zonePointLimit: 'Point limit',
    zonePointLimitReached: 'Your point limit is reached. Delete an existing point or increase the limit first.',
    backToDashboard: '← TO DASHBOARD',
    termTitle: 'profile.exe',
  },

  // ── Home page ─────────────────────────────────────────────────────
  home: {
    playBtn : '▶ PLAY',
    history: 'HISTORY',
    signIn: 'SIGN IN',
    register: 'REGISTER',
    myPixels  : 'MY PIXELS',
    profileBtn: 'PROFILE',
    zonesBtn  : 'MY ZONES',
    shopBtn   : 'SUBSCRIPTION',
    logout    : 'LOGOUT',
  },

  // ── Dashboard ─────────────────────────────────────────────────────
  dashboard: {
    title: 'MY PIXELS',
    subtitle: '',
    backToMap: '← TO CANVAS',
    profileBtn: 'PROFILE',
    adminBtn: 'ADMIN',
    logoutBtn: 'LOGOUT',
    pointsStats: 'POINTS:',
    lastActive: 'LAST ACTIVE:',
    emptyLine1: 'NO PIXELS YET.',
    emptyLine2: 'CREATE YOUR FIRST ONE.',
    searchPlaceholder: 'SEARCH BY NAME OR COORDS...',
    noResults: 'NO RESULTS FOR "{{query}}"',
    prev: '← PREV',
    next: 'NEXT →',
    loading: 'LOADING',
    errFetch: 'Failed to load pixels',
    errCreate: 'Failed to create pixel',
    errDelete: 'Failed to delete pixel',
    errRename: 'Failed to rename pixel',
    errColor: 'Failed to change color',
    shopBtn : 'SUBSCRIPTION',
    zonesBtn: 'MY ZONES',
    subscriptionLabel: 'SUBSCRIPTION:',
    subscriptionActiveUntil: 'ACTIVE UNTIL {{date}}',
    subscriptionInactive: 'INACTIVE',
    ownedColorsLabel: 'MY COLORS:',
    tabPixels : 'MY PIXELS',
    tabShop   : 'SHOP',
    tabZones  : 'MY ZONES',
    tabProfile: 'PROFILE',
  },

  // ── Point card ────────────────────────────────────────────────────
  pointCard: {
    play: '▶ PLAY',
    rename: '✎ RENAME',
    color: '🎨 COLOR',
    del: '✕ DEL',
    renameTitle: 'RENAME POINT',
    colorTitle: 'CHOOSE COLOR',
    deleteTitle: 'DELETE POINT?',
    deleteConfirm: '"{{name}}" will be permanently deleted.',
    saveBtn: '✎ SAVE',
    applyBtn: '✔ APPLY',
    deleteBtn: '✕ DELETE',
    defaultColor: 'DEFAULT',
  },

  // ── Create point ──────────────────────────────────────────────────
  createPoint: {
    btn: 'CREATE NEW POINT',
    limitReached: 'POINT LIMIT REACHED',
    title: 'CREATE NEW POINT',
    namePlaceholder: 'My Pixel',
    hint: 'Leave empty to use default name. Coordinates are assigned automatically.',
    createBtn: '▶ CREATE',
  },

  // ── Game ──────────────────────────────────────────────────────────
  game: {
    pointLabel: 'POINT #{{id}}',
    colorLabel: 'COLOR:',
    pointsLabel: 'POINTS:',
    dashboardBtn: 'DASHBOARD',
    canvasBtn: 'CANVAS',
    colorBtn: 'COLOR',
    addPointBtn: 'POINT',
    moreActions: 'MORE',
    controlsLayout: 'CONTROLS',
    controls_onehand: 'ONE HAND',
    controls_split: 'TWO HANDS',
    controls_taps: 'AREAS',
    controlsHand: 'HAND',
    hand_right: 'RIGHT',
    hand_left: 'LEFT',
    controlsSize: 'D-PAD SIZE',
    size_compact: 'COMPACT',
    size_large: 'LARGE',
    controlsGridBrightness: 'GRID BRIGHTNESS',
    switchPixelBtn: 'SWITCH',
    switchPixelHint: 'TAP A PIXEL TO SWITCH — TAP BACKGROUND TO CANCEL',
    createPointTitle: 'CREATE NEW POINT',
    namePlaceholder: 'Name (optional)',
    chooseColorTitle: 'CHOOSE COLOR',
    gridOn: 'GRID ON',
    gridOff: 'GRID OFF',
    creating: '...',
    createBtn: 'CREATE',
    errCreate: 'Failed to create pixel',
    errColor: 'Failed to change color',
    deletePointBtn: 'DELETE',
    deleteConfirmTitle: 'DELETE PIXEL?',
    deleteConfirmText: 'Pixel #{{id}} will be permanently deleted.',
    deleteConfirmBtn: 'DELETE',
    errDelete: 'Failed to delete pixel',
    helpBtn: 'HELP',
    helpTitle: 'HOW TO PLAY',
    helpMove: 'Move pixel',
    helpColor: 'Open color picker',
    helpGrid: 'Toggle grid',
    helpCreate: 'Create new pixel',
    helpDelete: 'Delete current pixel',
    helpImpassable: 'Toggle impassable wall',
    sayBtn        : 'SAY',
    sayPlaceholder: 'Say something...',
    sayJump       : 'JUMP',
    jumpBtn       : 'JUMP',
    gotoBtn        : 'GO TO',
    gotoCancel     : 'CANCEL',
    gotoHint       : 'TAP A CELL TO SET DESTINATION',
    gotoGo         : 'GO',
    gotoStop       : 'STOP',
    gotoWalking    : 'WALKING…',
    gotoUnreachable: "Can't reach that cell",

    helpSectionControls : 'KEYBOARD CONTROLS',
    helpSectionHud      : 'HUD BUTTONS',
    helpSectionMechanics: 'MECHANICS',
    helpSectionColors   : 'COLORS',
    helpSectionZones    : 'ZONES',

    helpHudDashboard: 'DASHBOARD — go to your pixel list',
    helpHudCanvas   : 'CANVAS — return to the home canvas',
    helpHudColor    : 'COLOR — change the color of the current pixel',
    helpHudPoint    : 'PIXEL — create a new pixel',
    helpHudSwitch   : 'SWITCH — tap your own pixel on the map to switch to it',
    helpHudZone     : 'ZONE — create or manage zone reservations',
    helpHudGrid     : 'GRID — toggle the coordinate grid overlay',
    helpHudShare    : 'SHARE — copy a link to the current view',
    helpHudGoto     : 'GO TO — tap a cell, then GO to auto-walk your pixel there',
    helpHudWall     : 'WALL — mark pixel as impassable (requires active zone)',
    helpHudDelete   : 'DELETE — permanently remove the current pixel',
    helpHudSay      : 'SAY — broadcast a speech bubble to all viewers (T key)',
    helpSay         : 'Open / close Say input',
    helpSayJump     : 'Open Say with jump enabled',
    helpJump        : 'Jump (visible to all)',
    speechStyleLocked: 'Speech styles are available with an active subscription',

    helpMechMove  : 'Move in 4 directions. Occupied cells are skipped — you jump to the next free cell in the same direction.',
    helpMechRate  : 'Rate limit: 5 moves per second (200 ms cooldown).',
    helpMechSync  : 'Field syncs instantly on each move, plus every 1 second.',
    helpMechCreate: 'New pixels spawn at the nearest free cell from world center (0, 0) via BFS.',

    helpColorFree   : '16 free colors — always available to all users.',
    helpColorPremium: 'Premium preset colors — buy individually (9 ₽) or subscribe (199 ₽/mo).',
    helpColorCustom : 'Any custom hex color — active subscription required.',

    helpZoneDesc   : 'Reserve a rectangular area (min 100×100 cells). Non-owner pixels idle inside are evicted after the configured timeout.',
    helpZoneWarning: 'Eviction warning is shown 15 s before timeout.',
    helpZoneFree   : 'Zones more than 3000 units from origin (0, 0) are free — 1 per user, max 100×100.',
    helpZoneWall   : 'WALL prevents others from jumping over your pixel. Only works inside your active zone. Eviction clears the wall.',

    impassableOn: 'WALL: ON',
    impassableOff: 'WALL: OFF',
    errImpassable: 'Failed to change wall status',
  },

  // ── History ───────────────────────────────────────────────────────
  history: {
    backBtn: '← BACK',
    playerTitle: 'HISTORY PLAYER',
    timeLabel: 'TIME',
    viewLabel: 'VIEW',
    fromLabel: 'FROM',
    toLabel: 'TO',
    loadingBtn: 'LOADING...',
    reloadBtn: 'RELOAD',

    staleReload: 'RELOAD AREA',


    activityHint: 'Timeline: drag to pan, wheel/pinch to zoom, the yellow band is the range (drag it or its edges), click to seek, long-press or double-click to bring the range here.',    truncated: 'first {{total}}+ shown — narrow the area or range',



    timelineExpand: 'Expand timeline',


    timelineCollapse: 'Collapse timeline',


    loadingEvents: 'loading events… {{n}}',


    activityLoading: 'computing activity…',    truncatedHint: 'The range holds more events than were loaded. Playback covers only the loaded part.',    loadBtn: 'LOAD',
    events: '{{index}} / {{total}} events',
    eventsEmpty: '—',
    modeLabel: 'MODE',
    fixedMode: 'FIXED',
    realtimeMode: 'REALTIME',
    evtPerS: 'EVT/S',
    speedLabel: 'SPEED',
    autoplayLabel: 'AUTOPLAY',
    autoplayHint: 'Adds ?play=1 to the URL — anyone opening the shared link sees playback start by itself',
    loadError: 'load error',
    setup: 'SETTINGS',
    playTitle: 'Play',
    pauseTitle: 'Pause',
    resetTitle: 'Reset to start',
    record: 'REC',
    recordTitle: 'Record timelapse',
    recording: 'RECORDING…',
    stop: 'STOP',
    stopTitle: 'Stop & save',
    encoding: 'ENCODING {{pct}}%',
    recordArea: 'AREA',
    selectArea: 'SELECT AREA',
    reselectArea: 'RESELECT',
    selectAreaHint: 'Drag a rectangle to frame the recording',
    frameMoveHint: 'Drag to move the window; corners and edges resize it',
    recordViewport: 'current view',
    recordLoadFirst: 'Load events before recording',
    recordUnsupported: 'Recording is not supported in this browser',
    recordGifNote: 'GIF fallback (no video support)',
    recordSaved: 'Timelapse saved',
    recordFailed: 'Recording failed',
  },

  // ── Admin ─────────────────────────────────────────────────────────
  admin: {
    title: 'ADMIN PANEL',
    backToDashboard: '← DASHBOARD',
    tabs: {
      users: 'USERS',
      stats: 'STATISTICS',
      events: 'RECENT EVENTS',
      import: 'IMPORT IMAGE',
      zones: 'ZONES',
      maze: 'MAZE',
      dialogue: 'DIALOGUES',
      connections: 'CONNECTIONS',
    },
    connections: {
      loadError: 'Failed to load connections',
      totalLabel: 'Total',
      playersLabel: 'Players',
      observersLabel: 'Observers',
      refreshHint: 'Updates every 3 s',
      showList: 'Show details',
      hideList: 'Hide details',
      noConnections: 'No active connections',
      colUser: 'User',
      colPoint: 'Point',
      colType: 'Type',
      colIP: 'IP',
      colArea: 'Viewport',
      colDuration: 'Duration',
      typePlayer: 'player',
      typeObserver: 'observer',
      prev: '‹ prev',
      next: 'next ›',
      pageInfo: '{{from}}–{{to}} of {{total}}',
    },
    users: {
      searchPlaceholder: 'Search by email...',
      searchBtn: 'FIND',
      loadError: 'Failed to load users',
      loadingText: 'loading...',
      colId: 'ID',
      colEmail: 'Email',
      colVerified: 'Verified',
      colAdmin: 'Admin',
      colPixels: 'Pixels',
      colMoves: 'Moves',
      colMaxPoints: 'Max points',
      colOAuth: 'OAuth',
      colActions: 'Actions',
      editBtn: 'edit',
      deleteBtn: 'del.',
      editTitle: 'Edit: {{email}}',
      maxPointsLabel: 'Max points',
      isAdminLabel: 'Administrator',
      savingBtn: 'SAVING...',
      saveBtn: 'SAVE',
      cancelBtn: 'CANCEL',
      deleteConfirm: 'Delete user {{email}}?',
    },
    stats: {
      loadError: 'Failed to load statistics',
      loadingText: 'loading...',
      daysBtn: '{{days}} days',
      moves: 'moves',
      created: 'created',
      deleted: 'deleted',
      movesTooltip: '{{day}}: {{count}} moves',
      noData: 'no data',
    },
    events: {
      loadError: 'Failed to load events',
      loadingText: 'loading...',
      colTime: 'Time',
      colType: 'Type',
      colUser: 'User',
      colPixel: 'Pixel',
      colCoords: 'Coordinates',
      colColor: 'Color',
      typeMove: 'move',
      typeCreated: 'created',
      typeDeleted: 'deleted',
      typeUpdated: 'updated',
    },
    import: {
      hint: 'Upload an image — pixels of the selected color (black or white) will be placed on the field starting at coordinate (X, Y). Occupied cells are skipped.',
      imageLabel: 'Image (PNG / JPEG / GIF)',
      startXLabel: 'Start X',
      startYLabel: 'Start Y',
      colorModeLabel: 'Place pixels of color',
      blackBtn: 'BLACK',
      whiteBtn: 'WHITE',
      thresholdLabel: 'Brightness threshold: {{value}}',
      thresholdBlack: 'brightness < {{value}}',
      thresholdWhite: 'brightness > {{value}}',
      pixelColorLabel: 'Pixel color',
      selectImageError: 'Select an image',
      importError: 'Import error',
      result: '{{created}} placed · {{skipped}} skipped',
      importingBtn: 'IMPORTING...',
      importBtn: 'IMPORT',
    },
    maze: {
      hint: 'Select an area on the map. A maze with impassable walls will be generated there and the zone will be reserved in your name.',
      nameLabel: 'Name',
      namePlaceholder: 'Maze name',
      wallColorLabel: 'Wall color',
      selectBtn: 'SELECT AREA ON MAP',
      selectAreaError: 'Select an area on the map first',
      selectedArea: 'Selected: ({{x1}}, {{y1}}) → ({{x2}}, {{y2}}) — {{w}}×{{h}} cells',
      generateBtn: 'GENERATE MAZE',
      generatingBtn: 'GENERATING...',
      result: 'Done! Zone #{{zone_id}}, {{walls}} walls placed. Entrance: ({{ex}}, {{ey}}), Exit: ({{exitx}}, {{exity}})',
      error: 'Generation error',
      animateLabel: 'Build gradually (for the time machine)',
      animatePaceMs: '{{ms}} ms per wall',
    },
    dialogue: {
      hint: 'Build a scene from two pixels: pick existing ones or create new ones, set their coordinates, then play a sequence of speech and jump commands.',
      actorA: 'PIXEL A',
      actorB: 'PIXEL B',
      pickExistingBtn: 'EXISTING',
      createNewBtn: 'NEW',
      pointLabel: 'Pixel',
      pointSearchPlaceholder: 'Search pixel by id, name, or email...',
      pickOnMapBtn: 'PICK ON MAP',
      ownerLabel: 'Owner',
      nameLabel: 'Name',
      namePlaceholder: 'Pixel name',
      xLabel: 'X',
      yLabel: 'Y',
      createPointBtn: 'CREATE PIXEL',
      savePointBtn: 'SAVE POSITION',
      createOnMapBtn: 'CREATE ON MAP',
      moveOnMapBtn: 'MOVE ON MAP',
      scriptTitle: 'SCRIPT',
      timelineTitle: 'TIMELINE PREVIEW',
      timelineDuration: 'Duration: {{duration}}',
      timelineSayPreview: 'Speech: {{text}}',
      timelineJumpPreview: 'Jump',
      timelineJumpFlag: 'with jump',
      timelineDelayFlag: 'delay {{delay}}',
      importBtn: 'IMPORT JSON',
      exportBtn: 'EXPORT JSON',
      addStepBtn: '+ STEP',
      playBtn: '▶ PLAY',
      playingBtn: 'PLAYING...',
      stopBtn: 'STOP',
      cmdSay: 'SAY',
      cmdJump: 'JUMP',
      deleteStepBtn: 'DELETE',
      textPlaceholder: 'Speech text',
      styleLockedHint: 'Speech styles are available only when the pixel owner has an active subscription',
      jumpWithSayLabel: 'Jump together with speech',
      mapPickExisting: 'Pick an existing pixel by clicking the world',
      mapPickPosition: 'Pick a world cell for creation or movement',
      mapPickExistingHint: 'Click an existing pixel on the live game field.',
      mapPickPositionHint: 'Click the target cell on the live game field.',
      mapNoPoint: 'There is no pixel in that cell.',
      errUserRequired: 'Pick an owner for the new pixel',
      errPointRequired: 'Select a pixel first',
      errPointLookup: 'Failed to load the selected pixel',
      errSavePoint: 'Failed to save pixel',
      errAllActorsReady: 'Both pixels must be selected or created first',
      errEmptySpeech: 'Speech text cannot be empty',
      errPlay: 'Failed to play the script',
      errImportInvalid: 'Invalid scenario file',
    },
    zones: {
      searchPlaceholder: 'Search by owner email or zone name...',
      loadError        : 'Failed to load zones',
      deleteConfirm    : 'Delete zone "{{name}}"?',
      createBtn        : '+ CREATE ZONE',
      createTitle      : 'CREATE ZONE FOR USER',
      userIdLabel          : 'User',
      userSearchPlaceholder: 'Search user by email...',
      coordsLabel      : 'Coordinates',
      isFreeLabel      : 'Free (permanent, no payment)',
      expiresAtLabel   : 'Expires at',
      errUserId        : 'Enter a valid user ID',
      errCreate        : 'Failed to create zone',
      errUpdate        : 'Failed to update zone',
      editTitle        : 'EDIT ZONE #{{id}}',
      colId            : 'ID',
      colOwner         : 'Owner',
      colName          : 'Name',
      colCoords        : 'Coordinates',
      colTimeout       : 'Timeout',
      colStatus        : 'Status',
      colExpires       : 'Expires',
      statusFree       : 'FREE',
      statusActive     : 'ACTIVE',
      statusPending    : 'PENDING',
    },
  },

  speech: {
    styleLabel: 'Speech style',
    styleLockedHint: 'Style selection requires an active subscription',
    stylePreview: 'style: {{style}}',
    styles: {
      default: 'Default',
      cloud: 'Cloud',
      neon: 'Neon',
      pixel: 'Pixel',
    },
  },

  // ── Shop ──────────────────────────────────────────────────────────
  shop: {
    title: 'COLOR SHOP',
    subtitle: 'unlock more colors',
    backBtn: '← DASHBOARD',
    subscriptionTitle: 'ALL COLORS · SUBSCRIPTION',
    subscriptionDesc: 'Get access to all premium colors and any custom hex color.',
    perk1: 'All premium preset colors',
    perk2: 'Any custom hex color (#RRGGBB)',
    perk3: 'Stack months — extend any time',
    inactive: 'No active subscription',
    activeUntil: 'Active until {{date}}',
    subPrice: '199 ₽ / mo',
    subscribeBtn: '▶ SUBSCRIBE',
    extendBtn: '▶ EXTEND',
    premiumTitle: 'PREMIUM COLORS · BUY ONE',
    premiumHint: 'Purchase individual colors. Each color is yours forever.',
    customTitle: 'CUSTOM HEX · SUBSCRIPTION ONLY',
    customHint: 'Any color you can type in the hex field requires an active subscription.',
    customAny: '...and any of 16 million colors',
    freeTitle: 'FREE COLORS',
    freeHint: 'Always available to every user at no cost.',
    free: 'FREE',
    owned: '✔ OWNED',
    buyFor: 'Buy for',
    lockedHint: '🔒 Locked — buy or subscribe',
    hexLockedHint: 'Not unlocked.',
    buyColorBtn: '🔓 Buy 9 ₽',
    colorAlreadyOwned: 'Already owned',
    goToShop: 'Or subscribe →',
    errBuy: 'Failed to purchase color',
    errSub: 'Failed to activate subscription',
    paymentSuccess: 'Payment successful! Your purchase is now active.',
    paymentFail: 'Payment was cancelled or failed. Please try again.',
  },

  // ── Zones ─────────────────────────────────────────────────────────
  zone: {
    reserveBtn      : 'ZONE',
    reserveTitle    : 'RESERVE AREA',
    namePlaceholder : 'Zone name',
    timeoutLabel    : 'Evict after (idle)',
    seconds         : 'sec',
    createBtn       : '▶ RESERVE',
    myZones         : 'MY ZONES IN THIS AREA',
    created         : 'Zone reserved successfully',
    deleted         : 'Zone removed',
    errCreate       : 'Failed to reserve zone',
    errDelete       : 'Failed to delete zone',
    errInvalidCoords: 'Invalid coordinates',
    evictionWarning : '⚠ Zone "{{name}}" — you will be evicted in {{seconds}}s',
    evicted         : 'You were evicted from zone "{{name}}"',
    zonesOn         : 'ZONES ON',
    zonesOff        : 'ZONES OFF',
    drawBtn         : '📐 DRAW',
    drawInstruction : 'Drag to select zone area',
    drawCancelBtn   : '✕ Cancel',
    priceLabel      : 'COST:',
    priceFree       : 'FREE (frontier zone)',
    priceAmount     : '{{amount}} ₽/month',
    priceCalculating: 'calculating...',
    freeHint              : 'Zones more than 3000 units from origin (0, 0) are free (1 per user).',
    freeHint2             : 'Your free zone quota is used. This frontier zone will be charged at the minimum rate.',
    expiresAt             : 'until {{date}}',
    pendingPayment        : 'pending payment',
    paymentSuccess        : 'Zone payment successful! Your zone is now active.',
    renewSuccess          : 'Zone renewed for another month.',
    errRenew              : 'Failed to renew zone',
    overlapWarning        : '⚠ This area overlaps an existing zone.',
    deleteConfirmTitle    : 'DELETE ZONE?',
    deleteConfirmText     : 'Zone "{{name}}" will be deleted. This cannot be undone.',
    deleteConfirmBtn      : '✕ DELETE',
    deleteNoRefund        : 'This zone has been paid for. Refunds are not available for early cancellation.',
    expiringWarning       : '⚠ Zone "{{name}}" expires in {{days}} day(s). Renew to keep it active.',
    renewBtn              : '↻ RENEW',
    renewingBtn           : 'RENEWING...',
    expiringSoonBanner    : '{{count}} zone(s) expire soon — renew to avoid losing them.',
  },

  // ── My zones page ─────────────────────────────────────────────────
  myZones: {
    title        : 'MY ZONES',
    subtitle     : 'reserved areas',
    empty        : 'You have no reserved zones yet.',
    createBtn    : 'RESERVE NEW ZONE',
    coordsLabel  : 'Coordinates',
    statFree     : 'FREE ZONE:',
    statTotal    : 'TOTAL ZONES:',
    statusFree   : 'FREE',
    statusActive : 'ACTIVE',
    statusExpired: 'EXPIRED',
    statusPending: 'AWAITING PAYMENT',
    deleteConfirm: 'Delete zone "{{name}}"?',
    payBtn       : '▶ PAY {{amount}} ₽',
    freeQuotaUsed: 'Your free frontier zone quota is used. Additional frontier zones are charged at the minimum rate.',
  },

  // ── Language switcher ─────────────────────────────────────────────
  lang: {
    en: 'EN',
    ru: 'RU',
  },

  // ── Cookie banner ─────────────────────────────────────────────────
  cookie: {
    text      : 'We use cookies for authentication and anonymous analytics (Yandex.Metrica, Google Analytics). Tracking only starts after you accept.',
    learnMore : 'Learn more',
    accept    : 'GOT IT',
  },

  // ── Connection indicator ──────────────────────────────────────────
  connDot: {
    status: {
      connecting   : 'Connecting…',
      connected    : 'Connected',
      reconnecting : 'Reconnecting…',
      disconnected : 'Disconnected',
    },
    lastMessage : 'Last message',
    msgCount    : 'Messages received',
    never       : 'never',
  },

  // ── About page ────────────────────────────────────────────────────
  about: {
    termTitle   : 'about.exe',
    heading     : 'ABOUT THE PROJECT',
    tabs: {
      about    : 'ABOUT',
      help     : 'HELP',
      contacts : 'CONTACTS',
      oferta   : 'OFFER',
      privacy  : 'PRIVACY',
    },
    desc1       : 'We Are Pixels is a multiplayer collaborative canvas where every registered user controls a single pixel in an infinite 2D world.',
    desc2       : 'Together, thousands of pixels form living pixel art — visible in real time by anyone. No coordination tools, no chat. Just movement.',
    desc3       : 'Features:',
    feat1       : 'Real-time world — watch pixels move live',
    feat2       : 'History player — replay the world\'s past',
    feat3       : 'Zone reservations — claim and protect your territory',
    feat4       : 'Color shop — unlock premium and custom colors',
    version     : 'Version 1.0 · 2025',
    emailLabel  : 'Email',
    telegramLabel: 'Telegram',
    legalLabel  : 'Legal entity',
    legalName   : 'We Are Pixels',
    ofertaTitle : 'PUBLIC OFFER AGREEMENT',
    aboutBtn    : 'ABOUT',
  },
} as const;

export default en;
